import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    width: '50%',
    padding: theme.spacings.sm,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: theme.spacings.sm,
  },
  bar: {
    flex: 1,
  },
});
